import type { AffiliateLinkMetrics } from '@metapic-apps/shared'
import { type Ref, ref, watch } from 'vue'

import { useApi } from '@/lib/helpers/api.helpers'
import { financeClient } from '@/lib/services/finance.service'

export const useAffiliateLinkMetrics = (linkIdRef: Ref<number | undefined>) => {
  const data = ref<AffiliateLinkMetrics>()

  const { loading, error, fetchMetrics } = useApi({
    fetchMetrics: async (linkId: number) => {
      data.value = await financeClient.affiliateLinkMetricsControllerGetMetrics(linkId)
    },
  })

  watch(
    linkIdRef,
    (linkId) => {
      if (linkId == null) {
        data.value = undefined
        return
      }
      void fetchMetrics(linkId)
    },
    { immediate: true },
  )

  return { data, isLoading: loading, error }
}
